import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "percentBlock",
    "percent"
  ]

  onCalculationMethodChange() {
    if (this.calculationMethod.value == "Set to $0.00") {
      this.percentBlockTarget.classList.add("hidden");
    } else {
      this.percentBlockTarget.classList.remove("hidden");
    }
  }

  connect() {
    this.calculationMethod = this.element.querySelector("[name=calculation_method]");
    this.calculationMethod.addEventListener("change", this.onCalculationMethodChange.bind(this));
    this.onCalculationMethodChange();
  }
}